import request from '@/utils/request'

// 查询知识产权-有效发明，维持10年列表
export function listYxfm10(query) {
  return request({
    url: '/web/zscq/yxfm10/list',
    method: 'get',
    params: query
  })
}

// 查询知识产权-有效发明，维持10年详细
export function getYxfm10(recid) {
  return request({
    url: '/web/zscq/yxfm10/' + recid,
    method: 'get'
  })
}

// 新增知识产权-有效发明，维持10年
export function addYxfm10(data) {
  return request({
    url: '/web/zscq/yxfm10',
    method: 'post',
    data: data
  })
}

// 修改知识产权-有效发明，维持10年
export function updateYxfm10(data) {
  return request({
    url: '/web/zscq/yxfm10/edit',

    method: 'post',
    data: data
  })
}

// 删除知识产权-有效发明，维持10年
export function delYxfm10(recid) {
  return request({
    url: '/web/zscq/yxfm10/remove/' + recid,

    method: 'post',
  })
}

// 导出知识产权-有效发明，维持10年
export function exportYxfm10(query) {
  return request({
    url: '/web/zscq/yxfm10/export',
    method: 'get',
    params: query
  })
}

export function importTemplate() {
  return request({
    url: '/web/zscq/yxfm10/importTemplate',
    method: 'get'
  })
}
